module.exports = __webpack_public_path__ + "static/media/huawei.efcc8fe7.png";